import './bootstrap';
import '../css/app.css';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import VueApexCharts from "vue3-apexcharts";
import { createPinia } from 'pinia';
import VueGtag from "vue-gtag";
import { createI18n } from 'vue-i18n';
import Avatar from "vue3-avatar";
import Tooltip from 'primevue/tooltip';
import vSelect from 'vue-select';
import * as Sentry from "@sentry/vue";

import 'vue-select/dist/vue-select.css';

const appName = import.meta.env.VITE_APP_NAME || 'Etisia';
const pinia = createPinia();

const i18n = createI18n({
    legacy: false,
    locale: localStorage.getItem('userLanguage') || 'sl',
    fallbackLocale: 'en',
    messages: loadLocaleMessages(),
});

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue, Ziggy)
            .use(VueApexCharts)
            .use(pinia)
            .use(vSelect)
            .use(VueGtag, {
                id: "GTM-KQWVD2C6",
                params: {
                    anonymize_ip: true
                }
            })
            .use(i18n)
            .component("avatar", Avatar)
            .directive('tooltip', Tooltip);

        // Initialize Sentry here
        Sentry.init({
            app,
            dsn: "https://30819ecf5ccd1e22035b3f6eb574469c@o4508442817134593.ingest.de.sentry.io/4508442980974672",
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
            ],
            // Adjust the following as per your needs
            tracesSampleRate: 1.0,
            tracePropagationTargets: ["localhost"],
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
        });

        app.mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});

window.test_mode = import.meta.env.DEV || false;

function loadLocaleMessages() {
    const locales = import.meta.globEager('./locales/**/*.json');
    const messages = {};

    for (const path in locales) {
        const matched = path.match(/\/locales\/(.+)\/(.+).json$/);
        if (matched && matched.length > 2) {
            const locale = matched[1];
            const component = matched[2];
            messages[locale] = messages[locale] || {};
            messages[locale][component] = locales[path].default;
        }
    }

    return messages;
}

